module.exports = __webpack_public_path__ + "OpenSans-Italic-383eba0e55ed778006d76428812d343c.woff2";